import React, { FC, useCallback, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom'
import { useAuth, useLastLocation, useRest, useUserName, useUserRole } from '../Context'
import { USER_IDLE_TIMEOUT } from '../../constants/ActiveSession'

export const UserActiveSession: FC = ({ children }) => {
  const { rest } = useRest()
  const location = useLocation()
  const { removeAuthAccessToken, removeAccessTokenData } = useAuth()
  const { removeUserName } = useUserName()
  const { removeUserRole } = useUserRole()
  const { saveLastLocation } = useLastLocation()

  const handleOnIdle = useCallback(async () => {
    try {
      const {
        data: { status },
      } = await rest({
        method: 'POST',
        url: 'logout',
        withCredentials: true,
      })

      if (status === 'success') {
        removeAccessTokenData()
        removeAuthAccessToken()
        removeUserName()
        removeUserRole()
        saveLastLocation(location.pathname)
        toast.success('Logout is successful')
        // eslint-disable-next-line
        console.error('Token expired')
      }
    } catch (err) {
      // eslint-disable-next-line
      console.log(err)
    }
  }, [
    rest,
    removeAccessTokenData,
    removeAuthAccessToken,
    removeUserName,
    removeUserRole,
    saveLastLocation,
    location.pathname,
  ])

  const { reset } = useIdleTimer({
    timeout: USER_IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    stopOnIdle: true,
  })

  useEffect(() => {
    reset()
    // eslint-disable-next-line
  }, [])

  return <>{children}</>
}
